/* global Plyr */

/**
 * Initialize Plyr players for given selectors
 * @param {string|string[]} selectors - CSS selector(s) for player elements
 * @param {Object} options - Plyr configuration options
 * @return {void}
 */
export function initPlayers(selectors, options = {}) {
  const selectorArray = Array.isArray(selectors) ? selectors : [selectors];

  selectorArray.forEach((selector) => {
    const playerList = document.querySelectorAll(selector);

    if (playerList && playerList.length) {
      Plyr.setup(playerList, options);
    }
  });
}

/**
 * Initialize video players with default options
 * @return {void}
 */
export function initVideoPlayers() {
  initPlayers('[data-ref="video-player"]');
}

/**
 * Initialize podcast players with default options
 * @return {void}
 */
export function initPodcastPlayers() {
  initPlayers('[data-element="podcast-player"]');
}
